module.exports = __webpack_public_path__ + "img/configuration_product_emt.6af1f507.png";